import { FunctionComponentElement, cloneElement } from 'react'

import { FormFieldConfig } from '../../../../features/ui-config'
import { getConfigTranslation } from '../../../helper/getConfigTranslation'

export function createLabel(
  config: FormFieldConfig,
  label?: JSX.Element,
  isRequired: boolean = false,
): FunctionComponentElement<any> | null {
  if (!label) return null

  const needRequiredSign = isRequired || config?.validation?.isRequired

  return cloneElement(label, {
    children: (
      <>
        {needRequiredSign && createRequiredSign()}
        {getConfigTranslation(config?.label)}
        {label.props.children}
      </>
    ),
    className: `text-sm font-bold	${label.props.className || ''}`,
  })
}

export function createRequiredSign(): JSX.Element {
  return <span className="text-red-500 font-bold mr-1">*</span>
}
